import {
  Box,
  CssBaseline,
  IconButton,
  Input,
  MenuItem,
  Select,
  Stack,
  ThemeProvider,
  Typography,
} from "@mui/material";
import React from "react";
import theme from "../../../config/theme";
import { StyledButton } from "../../../components/common/Button";
import { countries } from "../../home/components/GetInTouch";
import { useState } from "react";
import { Circle } from "@mui/icons-material";
import Loginimg from "../../../assets/Loginimg.png";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import { createUser } from "../../../api";

const Onboarding = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [formData, setFormData] = useState({
    name: "",
    nameOfSchool: "",
    designation: "",
    email: "",
    phone: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const [selectedCountry, setSelectedCountry] = useState(countries[0]);
  const [countryCode, setCountryCode] = useState(selectedCountry.code);

  const handleCountryChange = (e) => {
    const selectedCountry = e.target.value;
    setSelectedCountry(selectedCountry);
    setCountryCode(selectedCountry.code);
  };

  const [activeOrganization, setActiveOrganization] = useState("INDEPENDENT");
  const organizationButton = [
    {
      title: "INDEPENDENT",
    },
    {
      title: "GROUP OF SCHOOLS",
    },
  ];

  const handleSignup = async () => {
    try {
      const userData = {
        name: formData.name,
        organizationType: activeOrganization,
        nameOfSchool: formData.nameOfSchool,
        designation: formData.designation,
        email: formData.email,
        phone: formData.phone,
      };

      const response = await createUser(userData);
      console.log("User created successfully:", response);
      navigate("/home");
    } catch (error) {
      console.error("Error creating user:", error);
      enqueueSnackbar("Error creating user", { variant: "error" });
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "50rem",
          backgroundImage: `url(${Loginimg})`,
          backgroundSize: "100%",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "bottom",
        }}
      >
        <Box sx={{ paddingTop: "3.75rem" }}>
          <Typography
            variant="h3"
            sx={{
              color: "#212121",
              fontWeight: 600,
              fontSize: "2rem",
              textAlign: "center",
            }}
          >
            Digitize your school within minutes using an <br /> integrated ERP platform
          </Typography>
        </Box>
        <Box
          sx={{
            marginTop: "3rem",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box>
            <Stack spacing={5} sx={{ m: 0 }}>
              <Box
                component="form"
                sx={{
                  "& > :not(style)": { m: 1 },
                  display: "flex",
                  flexDirection: "column",
                  width: "32rem",
                }}
                noValidate
                autoComplete="off"
                onChange={handleChange}
              >
                <Input
                  name="name"
                  value={formData.name}
                  placeholder="Your Name"
                />
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.5rem",
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontSize: "0.875rem",
                      fontWeight: 400,
                      color: "#6A6A6A",
                    }}
                  >
                    Select Organization Type
                  </Typography>
                  <Box sx={{ display: "flex", gap: "1rem" }}>
                    {organizationButton.map((item, index) => (
                      <StyledButton
                        key={index}
                        variant="contained"
                        height="2.5rem"
                        width="15.5rem"
                        style={{
                          backgroundColor:
                            activeOrganization === item.title
                              ? "#FFF"
                              : "#EEF6FF",
                          color:
                            activeOrganization === item.title
                              ? theme.palette.primary.main
                              : "#212121",
                          border:
                            activeOrganization === item.title
                              ? `1px solid ${theme.palette.primary.main}`
                              : "none",
                          borderRadius: "0.5rem",
                        }}
                        onClick={() => setActiveOrganization(item.title)}
                      >
                        <IconButton sx={{ marginRight: "0.69875rem" }}>
                          <Circle
                            style={{
                              height: "0.875rem",
                              width: "0.875rem",
                              color:
                                activeOrganization === item.title
                                  ? theme.palette.primary.main
                                  : "#FFF",
                            }}
                          />
                        </IconButton>
                        <Typography
                          sx={{
                            fontSize: "0.8125rem",
                            fontWeight: 700,
                            color: "#212121",
                            letterSpacing: "0.078125rem",
                          }}
                        >
                          {item.title}
                        </Typography>
                      </StyledButton>
                    ))}
                  </Box>
                </Box>
                <Input
                  name="nameOfSchool"
                  value={formData.nameOfSchool}
                  placeholder="Name of your School"
                />
                <Input
                  name="designation"
                  value={formData.designation}
                  placeholder="Your role/designation"
                />
                <Input
                  name="email"
                  value={formData.email}
                  placeholder="Email ID"
                />
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Select
                    value={selectedCountry}
                    onChange={handleCountryChange}
                    variant="standard"
                    sx={{ marginRight: "0.75rem" }}
                  >
                    {countries.map((country) => (
                      <MenuItem key={country.code} value={country}>
                        {country.flag}
                      </MenuItem>
                    ))}
                  </Select>
                  <Input
                    name="phone"
                    value={`+${countryCode}`}
                    placeholder="Country Code"
                    sx={{ width: "10%" }}
                    readOnly
                  />
                  <Input
                    name="phone"
                    value={formData.phone}
                    placeholder="Mobile No."
                    sx={{ width: "100%", marginLeft: "0.75rem" }}
                  />
                </Box>
                <Box sx={{ marginTop: "2rem" }}>
                  <StyledButton
                    variant="contained"
                    height="3rem"
                    width="15.5rem"
                    style={{ backgroundColor: `${theme.palette.primary.main}` }}
                    onClick={handleSignup}
                  >
                    SIGNUP
                  </StyledButton>
                </Box>
              </Box>
            </Stack>
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default Onboarding;
